<template>
  <span>
    <dt>{{ label }}</dt>
    <dd>{{ subjectValue | runFilter(subjectFilter) }}</dd>
    <dd>{{ partnerValue | runFilter(partnerFilter) }}</dd>
  </span>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { EmployerType } from '@/constants';

export default {
  props: ['label', 'property', 'filter', 'source'],
  computed: {
    ...mapState(['ui', 'inputs', 'inferred', 'results']),
    includePartner() {
      return this.inputs.IncludePartner.value;
    },
    sourceValue() {
      return this.source || 'inputs';
    },
    subjectValue() {
      const key = `${this.sourceValue}.${this.property}.value`;
      const employerType = this.inferred.EmployerType.value;

      if (this.property === 'MemberContributions' && this.isNotGovernmentWorker(employerType)) {
        return 'N/A';
      } if (this.property === 'EmployerContributionRate' && this.isSelfEmployed(employerType)) {
        return 'N/A';
      }

      return _.get(this, key);
    },
    subjectFilter() {
      return this.subjectValue !== 'N/A' ? this.filter : '';
    },
    partnerValue() {
      const key = `${this.sourceValue}.${this.property}_2.value`;
      const employerType = this.inferred.EmployerType_2.value;

      if (this.property === 'MemberContributions' && this.isNotGovernmentWorker(employerType)) {
        return 'N/A';
      } if (this.property === 'EmployerContributionRate' && this.isSelfEmployed(employerType)) {
        return 'N/A';
      }

      return this.includePartner ? _.get(this, key) : 'N/A';
    },
    partnerFilter() {
      return this.includePartner && this.partnerValue !== 'N/A' ? this.filter : '';
    },
  },
  methods: {
    isNotGovernmentWorker(employerType) {
      return employerType !== EmployerType.GOVERNMENT;
    },
    isSelfEmployed(employerType) {
      return employerType === EmployerType.SELF_OR_NOT_EMPLOYED;
    },
  },
};
</script>
